import { useEffect, useState } from "react";
import { Share, X, PlusSquare } from "lucide-react";

const KEY = "mhh_install_tip_seen";

const isPhone = () => /iphone|ipod|android.*mobile|mobile/i.test(navigator.userAgent) || window.innerWidth < 640;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const isInstalled = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function InstallPrompt() {
  const [show, setShow] = useState(false);
  const [deferred, setDeferred] = useState(null);

  useEffect(() => {
    if (localStorage.getItem(KEY) || isInstalled() || !isPhone()) return undefined;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const t = setTimeout(() => setShow(true), 2500);
    return () => {
      clearTimeout(t);
      window.removeEventListener("beforeinstallprompt", onPrompt);
    };
  }, []);

  const close = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    close();
  };

  if (!show) return null;
  return (
    <div data-testid="install-prompt" className="fade-up fixed inset-x-3 bottom-3 z-[1000] rounded-2xl border border-[#fde68a]/40 bg-zinc-950/95 p-4 shadow-2xl backdrop-blur-md">
      <button data-testid="install-prompt-close" onClick={close} aria-label="Close" className="absolute right-2 top-2 rounded-full p-1.5 text-zinc-400 hover:text-white">
        <X size={16} />
      </button>
      <div className="flex items-start gap-3 pr-6">
        <img src="/logo192.png" alt="" className="h-12 w-12 shrink-0 rounded-xl" />
        <div>
          <p className="font-heading text-2xl leading-none text-[#fde68a]">Add My Happy Hour to your home screen</p>
          <p className="mt-1 text-sm text-zinc-300">One tap to tonight's deals, just like an app.</p>
          {deferred ? (
            <button data-testid="install-prompt-install" onClick={install} className="mt-3 rounded-full bg-[#fde68a] px-4 py-2 text-sm font-bold text-zinc-950">
              Add to Home Screen
            </button>
          ) : isIOS() ? (
            <p data-testid="install-prompt-ios-steps" className="mt-2 flex flex-wrap items-center gap-1 text-sm text-zinc-200">
              Tap <Share size={15} className="text-[#fde68a]" /> Share, then <PlusSquare size={15} className="text-[#fde68a]" /> <b>Add to Home Screen</b>
            </p>
          ) : (
            <p data-testid="install-prompt-android-steps" className="mt-2 text-sm text-zinc-200">
              Tap the <b>⋮</b> menu, then <b>Add to Home screen</b>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
